import React from 'react';
import { ImageOptimizeProps } from './interface';

const ImageColOptimize: React.FC<ImageOptimizeProps> = props => {
  const { tips = ['原图', '处理后'], imgList } = props;


  return (
    <>
      {
        <div className="ai-demo-showroom">
          <div className="ai-demo-showroom__status"></div>
          <div className="ai-demo-showroom__container" data-label="请先上传人物图像">
            <div className="ai-demo-showroom__image">
              <div className="ai-demo-showroom-image-board-wrap">
                <div className="ai-demo-showroom-image-board-1  cur">
                  <i className="ai-demo-showroom-image-board-tips">{tips[0]}</i>
                  <img className="ai-demo-showroom-image-board-img" src={imgList[0]} alt="" />
                </div>
                <div className="ai-demo-showroom-image-board-3">
                  <i className="ai-demo-showroom-image-board-tips">{tips[1]}</i>
                  <img className="ai-demo-showroom-image-board-img" alt="" src={imgList[1]} />
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default ImageColOptimize;
